
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, Container, InputGroup } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../../routes";
import { useState } from "react";
import { resetPassword } from "../../api/services";
import { useHistory } from "react-router-dom";
import Preloader from "../../components/Preloader"; // Path to your code above

export default () => {
  const [email, setEmail] = useState("");
  const history = useHistory();
  const [error, setError] = useState("");
  const [showLoader, setShowLoader] = useState(false); // Controls the loader
  const handleLostPassword = async (e) => {
    console.log("handleLostPassword password clicked");
    e.preventDefault();
    setShowLoader(true);
    console.log({ email });
    try {
      const data = await resetPassword({
        email,
      });
      console.log("Password reset email sent:", data);
      sessionStorage.setItem("email", email);
      console.log("Email stored in sessionStorage:", sessionStorage.getItem("email"));
      history.push(Routes.ResetPassword.path);
    } catch (error) {
      console.error("Error sending password reset email:", error);
      setError( "Please sign up with this email first");
    }
    finally {
      setShowLoader(false);
    }
  };
  return (
    <main>
      <Preloader show={showLoader} />
      <section className="vh-lg-100 mt-4 mt-lg-0 bg-soft d-flex align-items-center">
        <Container>
          <Row className="justify-content-center">
            <p className="text-center">
              <Card.Link as={Link} to={Routes.Signin.path} className="text-gray-700">
                <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to sign in
              </Card.Link>
            </p>
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <div className="signin-inner my-3 my-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <h3>Forgot your password?</h3>
                {error && (<div class="alert alert-danger">
                  {error}
                </div>)}
                <p className="mb-4">Don't fret! Just type in your email and we will send you a code to reset your password!</p>
                <Form>
                  <div className="mb-4">
                    <Form.Label htmlFor="email" >Your Email</Form.Label>
                    <InputGroup id="email">
                      <Form.Control required autoFocus type="email" onChange={(e) => setEmail(e.target.value)} placeholder="john@company.com" />
                    </InputGroup>
                  </div>
                  <Button variant="primary" type="submit" onClick={handleLostPassword} className="w-100">
                    Recover password
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
